import { formatRFC3339 } from "date-fns";
import { v4 } from "uuid";
export class EventBase {
    #id;
    #eventType;
    #context;
    #timestamp;
    constructor({ id, eventType, context, timestamp, }) {
        this.#id = id ?? v4();
        this.#eventType = eventType;
        this.#context = context;
        this.#timestamp = timestamp ?? formatRFC3339(Date.now());
    }
    get id() {
        return this.#id;
    }
    get eventType() {
        return this.#eventType;
    }
    get context() {
        return this.#context;
    }
    get timestamp() {
        return this.#timestamp;
    }
    static create(value) {
        return new this.prototype.constructor({
            id: v4(),
            context: value,
            eventType: this.prototype.expectedEventType,
            timestamp: formatRFC3339(Date.now()),
        });
    }
    static matches(input) {
        if (Object.prototype.hasOwnProperty.call(input, "eventType")) {
            return input.eventType === this.prototype.expectedEventType;
        }
        return false;
    }
    marshal() {
        return JSON.stringify({
            id: this.id,
            domain: this.domain,
            eventType: this.eventType,
            context: this.context,
            timestamp: this.timestamp,
        });
    }
}
